// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1aolq","inputWrap":"CustomTip_inputWrap__3b4Qi"};